$(document).ready(function(){
       
    
    /*
     * Datepicker aktivieren
     */
    if($('.edt-datepicker input').length !== 0){
        $('.edt-datepicker input').datepicker({
            language: 'de',
            autoclose: true,
            disableTouchKeyboard: true
        });
    }
    
    
    /*
     * Reiseübersicht Text trimmen
     */
    if($('.ov-item-cont > p').length !== 0){
        $('.ov-item-cont > p').each(function(inx, item){
            if($(item).html().length > 150){
                $(item).html($(item).html().substring(0, 150)+"...");
            }
        });
    }
    
    
});